import { PostsApi } from '../../generated/api';
import configuration from './configuration';

export default new PostsApi(configuration);
